/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { HandlerGroupFactoryDeps } from 'src/core/types/handler';
import { CommonEntityHandlerGroup, createCommonEntityHandlerGroup } from 'src/luis/projects/entities/handlers/commonEntityHandlerGroup';
import {
    CompositeEntityHandlerGroup,
    createCompositeEntityHandlerGroup
} from 'src/luis/projects/entities/handlers/compositeEntityHandlerGroup';
import { createEntityRoleHandlerGroup, EntityRoleHandlerGroup } from 'src/luis/projects/entities/handlers/entityRoleHandlerGroup';
import {
    createHierarchicalEntityHandlerGroup,
    HierarchicalEntityHandlerGroup
} from 'src/luis/projects/entities/handlers/hierarchicalEntityHandlerGroup';
import { createListEntityHandlerGroup, ListEntityHandlerGroup } from 'src/luis/projects/entities/handlers/listEntityHandlerGroup';
import {
    createPatternAnyEntityHandlerGroup,
    PatternAnyEntityHandlerGroup
} from 'src/luis/projects/entities/handlers/patternAnyHandlerGroup';
import {
    createPrebuiltEntityHandlerGroup,
    PrebuiltEntityHandlerGroup
} from 'src/luis/projects/entities/handlers/prebuiltEntityHandlerGroup';
import { createRegexEntityHandlerGroup, RegexEntityHandlerGroup } from 'src/luis/projects/entities/handlers/regexEntityHandlerGroup';
import { createSimpleEntityHandlerGroup, SimpleEntityHandlerGroup } from 'src/luis/projects/entities/handlers/simpleEntityHandlerGroup';

export type EntityHandlerGroup = CommonEntityHandlerGroup &
    CompositeEntityHandlerGroup &
    ListEntityHandlerGroup &
    EntityRoleHandlerGroup &
    PatternAnyEntityHandlerGroup &
    RegexEntityHandlerGroup &
    SimpleEntityHandlerGroup &
    PrebuiltEntityHandlerGroup &
    HierarchicalEntityHandlerGroup;

/**
 * Creates a common entity handler group.
 *
 * @param dependencies The dependencies for the handler group.
 * @returns A collective handler group.
 */
export const createEntityHandlerGroup = (dependencies: HandlerGroupFactoryDeps) => ({
    ...createCommonEntityHandlerGroup(dependencies),
    ...createCompositeEntityHandlerGroup(dependencies),
    ...createEntityRoleHandlerGroup(dependencies),
    ...createListEntityHandlerGroup(dependencies),
    ...createPatternAnyEntityHandlerGroup(dependencies),
    ...createRegexEntityHandlerGroup(dependencies),
    ...createSimpleEntityHandlerGroup(dependencies),
    ...createPrebuiltEntityHandlerGroup(dependencies),
    ...createHierarchicalEntityHandlerGroup(dependencies)
});
